import React, { useState, useEffect, useRef, useCallback } from 'react';

import Bus from '../../../../../assets/images/landingPage/icons/onibus-219x264.png';
import MultiBus from '../../../../../assets/images/landingPage/icons/linhas202-219x264.png';
import BH from '../../../../../assets/images/landingPage/icons/bh-219x264.png';
import BannerImage from '../../../../../assets/images/landingPage/shutterstock-2237665557-2000x1124.jpg';

import Background from '../../../../../assets/images/landingPage/fundo-2-1920x1080.webp';


import { BaseComp, BaseContent, TextBody, TextContent, TextTitle, IconsContent, DefaultBox, IconImg, IconImgMulti, BannerContent, BannerImg } from './styles';
import { jarallax } from 'jarallax';

interface INavBar {

}



const NossosNumeros: React.FC<INavBar> = () => {
    const ref = useRef<HTMLDivElement>(null);
  const [counts, setCounts] = useState({ veiculo: 0, linhas: 0, cobertura: 0 });
  const targets = { veiculo: 2000, linhas: 300, cobertura: 100 };
  const [isVisible, setIsVisible] = useState(false);
  
    // Observer
    useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.disconnect();
          }
        },
        { threshold: 0.1 }
      );
      if (ref.current) observer.observe(ref.current);
      return () => observer.disconnect();
    }, []);
  
    const animateCounters = useCallback(() => {
    if (!isVisible) return;

    let start: number | null = null;
    const duration = 2000; // 2 segundos de animação
    const step = (timestamp: number) => {
      if (!start) start = timestamp;
      const progress = Math.min((timestamp - start) / duration, 1);

      setCounts((prev) => ({
        veiculo: Math.floor(progress * targets.veiculo),
        linhas: Math.floor(progress * targets.linhas),
        cobertura: Math.floor(progress * targets.cobertura),
      }));

      if (progress < 1) {
        requestAnimationFrame(step);
      }
    };

    requestAnimationFrame(step);
  }, [isVisible]);

  useEffect(() => {
    if (isVisible) {
      animateCounters();
    }
  }, [isVisible, animateCounters]);

  useEffect(() => {
  const elements = document.querySelectorAll('.jarallax');

  jarallax(elements, {
    speed: 0.4,
  });

  return () => jarallax(elements, 'destroy');
}, []);


    return (
        <BaseComp id='num' ref={ref}>
            <BaseContent>
                <TextContent className="jarallax" data-jarallax data-speed="0.4">
                  <img className="jarallax-img" src={Background} alt="" />
                    <TextTitle>
                        <h1>COM O BHBUS MÍDIA, A SUA MARCA ESTARÁ EXPOSTA EM:</h1>
                    </TextTitle>
                </TextContent>
                <IconsContent>
                    <DefaultBox>
                        <h1 className="growing-text">+{counts.linhas}</h1>
                        <h3 className="growing-text">Linhas</h3>
                        <IconImgMulti src={MultiBus} />
                    </DefaultBox>
                    <DefaultBox>
                        <h1 className="growing-text">+{counts.veiculo}</h1>
                        <h3 className="growing-text">Veículos</h3>
                        <IconImg src={Bus} />
                    </DefaultBox>
                    <DefaultBox>
                        <h1 className="growing-text">{counts.cobertura}%</h1>
                        <h3 className="growing-text">Cobertura em BH</h3>
                        <IconImg src={BH} />
                    </DefaultBox>
                </IconsContent>
            </BaseContent>
            <BannerContent className="jarallax" data-jarallax data-speed="0.4">
              <img className="jarallax-img" src={BannerImage} alt="" />
            </BannerContent>
        </BaseComp>
    );
}

export { NossosNumeros }